export enum ImportOrderValidationAnalyticsMessages {
  capability = 'orders',
  pageLoadEvent = 'page loaded',
  pageName = 'usfoods:r4:validate import',
  submitFileEvent = 'submit import',
  fileType = 'import:order:',
}
